// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 93) return "static/chunks/93-875cdbd7a4491768afef.js";
	if (chunkId === 3764) return "static/chunks/3764-4c2af7614988ea44daec.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2088":"7dc61650","4027":"ddc9e94f","6294":"VideoPlayerNew"}[chunkId] || chunkId) + "." + {"2088":"bcd507dfdc2aa26279c0","4027":"dec9d14cf65dbbe9d4b3","4833":"6f2cd67ecc11ecd240b5","6294":"3a9d0cd26b7e5e5af840"}[chunkId] + ".js";
};